module.exports = __webpack_public_path__ + "img/key.38d57d51.png";